// Store simples para favoritos usando localStorage
export default {
  getFavoritos() {
    const favoritos = localStorage.getItem('favoritos')
    return favoritos ? JSON.parse(favoritos) : []
  },

  // Normaliza o ID para garantir comparação correta (número ou string)
  normalizeId(id) {
    // Converte para número se possível, senão mantém como string
    const numId = Number(id)
    return isNaN(numId) ? String(id) : numId
  },

  adicionarFavorito(produtoId) {
    const id = this.normalizeId(produtoId)
    const favoritos = this.getFavoritos()
    // Verifica se já existe (comparando tanto como número quanto como string)
    const existe = favoritos.some(favId => 
      this.normalizeId(favId) === id || favId === id
    )
    if (!existe) {
      favoritos.push(id)
      localStorage.setItem('favoritos', JSON.stringify(favoritos))
    }
    return favoritos
  },

  removerFavorito(produtoId) {
    const id = this.normalizeId(produtoId)
    const favoritos = this.getFavoritos().filter(favId => 
      this.normalizeId(favId) !== id && favId !== id
    )
    localStorage.setItem('favoritos', JSON.stringify(favoritos))
    return favoritos
  },

  toggleFavorito(produtoId) {
    const id = this.normalizeId(produtoId)
    const favoritos = this.getFavoritos()
    const existe = favoritos.some(favId => 
      this.normalizeId(favId) === id || favId === id
    )
    if (existe) {
      return this.removerFavorito(produtoId)
    } else {
      return this.adicionarFavorito(produtoId)
    }
  },

  isFavorito(produtoId) {
    const id = this.normalizeId(produtoId)
    const favoritos = this.getFavoritos()
    return favoritos.some(favId => 
      this.normalizeId(favId) === id || favId === id
    )
  },

  limparFavoritos() {
    localStorage.removeItem('favoritos')
    return []
  },

  getTotalFavoritos() {
    return this.getFavoritos().length
  }
}

